import { render, staticRenderFns } from "./App.vue?vue&type=template&id=f1d18f5e"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=f1d18f5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../usr/local/share/.config/yarn/global/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports